export default __webpack_public_path__ + "static/media/reply_white_48dp.5b1adeca.svg";